import { httpClient } from './httpClient';

export const createCheckoutSession = async (companyId, priceId, mode, trial_days = null, campaignCode = null, userId = null, promotionCode = null, couponCode = null, memberId = null) => {
  const response = await httpClient.post(`/create-checkout-session`, 
    {
      company_id: companyId,
      price_id: priceId,
      mode, trial_days,
      campaign_code: campaignCode,
      user_id: userId,
      promotion_code: promotionCode,
      coupon_code: couponCode,
      member_id: memberId
    })
  return response.data
}